export default __webpack_public_path__ + "static/media/monkey21.d8d09af0.jpeg";